import { render, staticRenderFns } from "./HotelsTableItem.vue?vue&type=template&id=1b4489b1&"
import script from "./HotelsTableItem.vue?vue&type=script&lang=js&"
export * from "./HotelsTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports